/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Heading_LabelInputs */

const ja_contact_heading_label = /** @type {(inputs: Contact_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

const en_contact_heading_label = /** @type {(inputs: Contact_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

/**
* | output |
* | --- |
* | "Contact Us" |
*
* @param {Contact_Heading_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_heading_label = /** @type {((inputs?: Contact_Heading_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Heading_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_heading_label(inputs)
	return en_contact_heading_label(inputs)
});